import Scrollbars from 'components/Scrollbars'
import { LeftSidebarView, ViewBody } from 'components/Sidebar'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import Loader from 'components/Loader'
import CardBlockerList from 'components/CardBlockerList'
import UserBlockersComponent from 'components/UserBlockers'
import Alert from 'components/Alert'

const UserBlockers = () => {
  return (
    <LeftSidebarView
      title={<FormattedMessage id='BLOCKERS_BY_USER_HEADER' />}
    >
      <Scrollbars>
        <UserBlockersComponent>
          {({ cardBlockers, isLoading }) =>
            <>
              {cardBlockers.length > 0 ? (
                <CardBlockerList
                  cardBlockers={cardBlockers}
                />
              ) : (
                <ViewBody>
                  <Alert>
                    <FormattedMessage id='BLOCKERS_BY_USER_NO_BLOCKERS' />
                  </Alert>
                </ViewBody>
              )}

              {isLoading && <Loader center />}
            </>
          }
        </UserBlockersComponent>
      </Scrollbars>
    </LeftSidebarView>
  )
}

export default UserBlockers
